'use client'

import { useTranslations } from 'next-intl'
import Image from 'next/image'
import Title from '@/app/components/common/Title'
import '@/app/styles/components/WhySearchWithUsWidget.css'

export default function WhySearchWithUsWidget() {
	const t = useTranslations('Main.whySearchWithUs')

	const features = [
		{
			id: 'savings',
			title: t('savings.title'),
			description: t('savings.description'),
			mobileImage: '/images/why-savings.webp',
			desktopImage: '/images/why-savings-desktop.webp',
			type: 'tall',
		},
		{
			id: 'community',
			title: t('community.title'),
			description: t('community.description'),
			mobileImage: '/images/why-community.webp',
			desktopImage: '/images/why-community-desktop.webp',
			type: 'small',
		},
		{
			id: 'deals',
			title: t('deals.title'),
			description: t('deals.description'),
			mobileImage: '/images/why-deal.webp',
			desktopImage: '/images/why-deal-desktop.webp',
			type: 'wide',
		},
		{
			id: 'everywhere',
			title: t('everywhere.title'),
			description: t('everywhere.description'),
			mobileImage: '/images/why-search.webp',
			desktopImage: '/images/why-search-desktop.webp',
			type: 'small',
		},
		{
			id: 'tailored',
			title: t('tailored.title'),
			description: t('tailored.description'),
			mobileImage: '/images/why-tailored.webp',
			desktopImage: '/images/why-tailored-desktop.webp',
			type: 'medium',
		},
	]

	const savingsFeature = features.find((f) => f.id === 'savings')
	const column2Features = features.filter((f) =>
		['community', 'deals'].includes(f.id)
	)
	const column3Features = features.filter((f) =>
		['everywhere', 'tailored'].includes(f.id)
	)

	return (
		<section className="why-search">
			<div className="container why-search__container">
				<Title level="3" className="why-search__title">
					{t('title')}
				</Title>

				<div className="why-search__grid">
					{/* Column 1: Savings */}
					<div className="why-search__grid-col why-search__grid-col--1">
						{savingsFeature && (
							<div
								key={savingsFeature.id}
								className={`why-search__card why-search__card--${savingsFeature.id} why-search__card--${savingsFeature.type}`}
							>
								<div className="why-search__card-content">
									<div className="why-search__card-icon-mobile">
										<div className="why-search__mobile-thumb">
											<Image
												src={savingsFeature.mobileImage}
												alt={savingsFeature.title}
												width={64}
												height={64}
												className="why-search__mobile-image"
											/>
										</div>
									</div>
									<div className="why-search__card-text">
										<h3 className="why-search__card-title">
											{savingsFeature.title}
										</h3>
										<p className="why-search__card-description">
											{savingsFeature.description}
										</p>
									</div>
								</div>
								<div className="why-search__card-graphic">
									<Image
										src={savingsFeature.desktopImage}
										alt=""
										width={400}
										height={400}
										className={`why-search__graphic-img why-search__graphic-img--${savingsFeature.id}`}
									/>
								</div>
							</div>
						)}
					</div>

					{/* Column 2: Community & Everywhere */}
					<div className="why-search__grid-col why-search__grid-col--2">
						{column2Features.map((feature) => (
							<div
								key={feature.id}
								className={`why-search__card why-search__card--${feature.id} why-search__card--${feature.type}`}
							>
								<div className="why-search__card-content">
									<div className="why-search__card-icon-mobile">
										<div className="why-search__mobile-thumb">
											<Image
												src={feature.mobileImage}
												alt={feature.title}
												width={64}
												height={64}
												className="why-search__mobile-image"
											/>
										</div>
									</div>
									<div className="why-search__card-text">
										<h3 className="why-search__card-title">{feature.title}</h3>
										<p className="why-search__card-description">
											{feature.description}
										</p>
									</div>
								</div>
								<div className="why-search__card-graphic">
									<Image
										src={feature.desktopImage}
										alt=""
										width={400}
										height={400}
										className={`why-search__graphic-img why-search__graphic-img--${feature.id}`}
									/>
								</div>
							</div>
						))}
					</div>

					{/* Column 3: Deals & Tailored */}
					<div className="why-search__grid-col why-search__grid-col--3">
						{column3Features.map((feature) => (
							<div
								key={feature.id}
								className={`why-search__card why-search__card--${feature.id} why-search__card--${feature.type}`}
							>
								<div className="why-search__card-content">
									<div className="why-search__card-icon-mobile">
										<div className="why-search__mobile-thumb">
											<Image
												src={feature.mobileImage}
												alt={feature.title}
												width={64}
												height={64}
												className="why-search__mobile-image"
											/>
										</div>
									</div>
									<div className="why-search__card-text">
										<h3 className="why-search__card-title">{feature.title}</h3>
										<p className="why-search__card-description">
											{feature.description}
										</p>
									</div>
								</div>
								<div className="why-search__card-graphic">
									<Image
										src={feature.desktopImage}
										alt=""
										width={400}
										height={400}
										className={`why-search__graphic-img why-search__graphic-img--${feature.id}`}
									/>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
		</section>
	)
}

